package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.automirrored.filled.StarHalf
import androidx.compose.material.icons.outlined.StarOutline
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.presentation.ui.BrandColors

@Composable
fun StarRatingBar(
    rating: Double,
    onRatingChange: (Double) -> Unit,
    modifier: Modifier = Modifier,
    starSize: Dp = 40.dp,
    enabled: Boolean = true,
    tint: Color = BrandColors.Primary
) {
    Row(
        modifier = modifier,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        for (star in 1..5) {
            val fill = (rating - (star - 1)).coerceIn(0.0, 1.0)
            val icon = when {
                fill >= 0.75 -> Icons.Filled.Star
                fill >= 0.25 -> Icons.AutoMirrored.Filled.StarHalf
                else -> Icons.Outlined.StarOutline
            }
            Box(
                modifier = Modifier
                    .size(starSize)
                    .pointerInput(enabled) {
                        if (!enabled) return@pointerInput
                        detectTapGestures { offset ->
                            val newRating = if (offset.x < size.width / 2f) star - 0.5 else star.toDouble()
                            onRatingChange(newRating)
                        }
                    },
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    imageVector = icon,
                    contentDescription = "$star stars",
                    tint = tint,
                    modifier = Modifier.size(starSize)
                )
            }
        }
    }
}
